module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/shopping/barcode-57ead296f6391876cde82159d572cc1e.svg";